import React from 'react';
import { FacebookIcon, TwitterIcon, InstagramIcon, YoutubeIcon, LinkedinIcon, MailIcon, PhoneIcon, MapPinIcon, ChevronRightIcon } from 'lucide-react';
export function Footer() {
  return <footer className="bg-gray-900 text-white" data-id="element-491">
      {/* Newsletter */}
      <div className="bg-blue-800 py-12" data-id="element-492">
        <div className="container mx-auto px-4" data-id="element-493">
          <div className="flex flex-col md:flex-row md:items-center md:justify-between" data-id="element-494">
            <div className="mb-6 md:mb-0 md:mr-12" data-id="element-495">
              <h3 className="text-xl font-bold mb-2" data-id="element-496">
                Subscribe to Our Newsletter
              </h3>
              <p className="text-blue-100" data-id="element-497">
                Get exclusive deals, travel tips, and more delivered to your
                inbox.
              </p>
            </div>
            <div className="flex-1 max-w-md" data-id="element-498">
              <form className="flex" data-id="element-499">
                <input type="email" placeholder="Your email address" className="flex-1 px-4 py-3 rounded-l-md text-gray-900 focus:outline-none" data-id="element-500" />
                <button className="bg-blue-600 hover:bg-blue-700 px-6 py-3 rounded-r-md font-medium transition-colors" data-id="element-501">
                  Subscribe
                </button>
              </form>
            </div>
          </div>
        </div>
      </div>
      {/* Main footer content */}
      <div className="py-12" data-id="element-502">
        <div className="container mx-auto px-4" data-id="element-503">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-8" data-id="element-504">
            {/* Company info */}
            <div className="lg:col-span-2" data-id="element-505">
              <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/dGmrTFD4H9KRDNXV9TQzMi/image.png" alt="EU Holidays Logo" className="h-10 mb-6" data-id="element-506" />
              <p className="text-gray-400 mb-6 max-w-md" data-id="element-507">
                Discover the world with EU Holidays. We offer unforgettable
                travel experiences with expertly crafted itineraries,
                exceptional service, and attention to detail.
              </p>
              <div className="flex space-x-4" data-id="element-508">
                <a href="#" className="text-gray-400 hover:text-white" data-id="element-509">
                  <FacebookIcon size={20} data-id="element-510" />
                </a>
                <a href="#" className="text-gray-400 hover:text-white" data-id="element-511">
                  <TwitterIcon size={20} data-id="element-512" />
                </a>
                <a href="#" className="text-gray-400 hover:text-white" data-id="element-513">
                  <InstagramIcon size={20} data-id="element-514" />
                </a>
                <a href="#" className="text-gray-400 hover:text-white" data-id="element-515">
                  <YoutubeIcon size={20} data-id="element-516" />
                </a>
                <a href="#" className="text-gray-400 hover:text-white" data-id="element-517">
                  <LinkedinIcon size={20} data-id="element-518" />
                </a>
              </div>
            </div>
            {/* Quick links */}
            <div data-id="element-519">
              <h4 className="text-lg font-semibold mb-4" data-id="element-520">Quick Links</h4>
              <ul className="space-y-2" data-id="element-521">
                <li data-id="element-522">
                  <a href="#" className="text-gray-400 hover:text-white flex items-center" data-id="element-523">
                    <ChevronRightIcon size={14} className="mr-2" data-id="element-524" /> Home
                  </a>
                </li>
                <li data-id="element-525">
                  <a href="#" className="text-gray-400 hover:text-white flex items-center" data-id="element-526">
                    <ChevronRightIcon size={14} className="mr-2" data-id="element-527" /> Destinations
                  </a>
                </li>
                <li data-id="element-528">
                  <a href="#" className="text-gray-400 hover:text-white flex items-center" data-id="element-529">
                    <ChevronRightIcon size={14} className="mr-2" data-id="element-530" /> Tour Types
                  </a>
                </li>
                <li data-id="element-531">
                  <a href="#" className="text-gray-400 hover:text-white flex items-center" data-id="element-532">
                    <ChevronRightIcon size={14} className="mr-2" data-id="element-533" /> Deals &
                    Offers
                  </a>
                </li>
                <li data-id="element-534">
                  <a href="#" className="text-gray-400 hover:text-white flex items-center" data-id="element-535">
                    <ChevronRightIcon size={14} className="mr-2" data-id="element-536" /> Travel Blog
                  </a>
                </li>
                <li data-id="element-537">
                  <a href="#" className="text-gray-400 hover:text-white flex items-center" data-id="element-538">
                    <ChevronRightIcon size={14} className="mr-2" data-id="element-539" /> About Us
                  </a>
                </li>
                <li data-id="element-540">
                  <a href="#" className="text-gray-400 hover:text-white flex items-center" data-id="element-541">
                    <ChevronRightIcon size={14} className="mr-2" data-id="element-542" /> Contact
                  </a>
                </li>
              </ul>
            </div>
            {/* Support */}
            <div data-id="element-543">
              <h4 className="text-lg font-semibold mb-4" data-id="element-544">Support</h4>
              <ul className="space-y-2" data-id="element-545">
                <li data-id="element-546">
                  <a href="#" className="text-gray-400 hover:text-white flex items-center" data-id="element-547">
                    <ChevronRightIcon size={14} className="mr-2" data-id="element-548" /> FAQ
                  </a>
                </li>
                <li data-id="element-549">
                  <a href="#" className="text-gray-400 hover:text-white flex items-center" data-id="element-550">
                    <ChevronRightIcon size={14} className="mr-2" data-id="element-551" /> Help Center
                  </a>
                </li>
                <li data-id="element-552">
                  <a href="#" className="text-gray-400 hover:text-white flex items-center" data-id="element-553">
                    <ChevronRightIcon size={14} className="mr-2" data-id="element-554" /> Payment
                    Options
                  </a>
                </li>
                <li data-id="element-555">
                  <a href="#" className="text-gray-400 hover:text-white flex items-center" data-id="element-556">
                    <ChevronRightIcon size={14} className="mr-2" data-id="element-557" /> Booking
                    Terms
                  </a>
                </li>
                <li data-id="element-558">
                  <a href="#" className="text-gray-400 hover:text-white flex items-center" data-id="element-559">
                    <ChevronRightIcon size={14} className="mr-2" data-id="element-560" /> Cancellation
                    Policy
                  </a>
                </li>
                <li data-id="element-561">
                  <a href="#" className="text-gray-400 hover:text-white flex items-center" data-id="element-562">
                    <ChevronRightIcon size={14} className="mr-2" data-id="element-563" /> Privacy
                    Policy
                  </a>
                </li>
                <li data-id="element-564">
                  <a href="#" className="text-gray-400 hover:text-white flex items-center" data-id="element-565">
                    <ChevronRightIcon size={14} className="mr-2" data-id="element-566" /> Cookie
                    Policy
                  </a>
                </li>
              </ul>
            </div>
            {/* Contact */}
            <div data-id="element-567">
              <h4 className="text-lg font-semibold mb-4" data-id="element-568">Contact Us</h4>
              <ul className="space-y-4" data-id="element-569">
                <li className="flex" data-id="element-570">
                  <MapPinIcon size={18} className="text-blue-400 mr-3 flex-shrink-0 mt-1" data-id="element-571" />
                  <span className="text-gray-400" data-id="element-572">
                    Bahnhofstrasse 100
                    <br data-id="element-573" />
                    8001 Zürich
                    <br data-id="element-574" />
                    Switzerland
                  </span>
                </li>
                <li className="flex items-center" data-id="element-575">
                  <PhoneIcon size={18} className="text-blue-400 mr-3 flex-shrink-0" data-id="element-576" />
                  <a href="tel:+41123456789" className="text-gray-400 hover:text-white" data-id="element-577">
                    +41 123 456 789
                  </a>
                </li>
                <li className="flex items-center" data-id="element-578">
                  <MailIcon size={18} className="text-blue-400 mr-3 flex-shrink-0" data-id="element-579" />
                  <a href="mailto:info@euholidays.com" className="text-gray-400 hover:text-white" data-id="element-580">
                    info@euholidays.com
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
      {/* Bottom bar */}
      <div className="border-t border-gray-800 py-6" data-id="element-581">
        <div className="container mx-auto px-4" data-id="element-582">
          <div className="flex flex-col md:flex-row md:items-center md:justify-between" data-id="element-583">
            <div className="text-gray-500 text-sm mb-4 md:mb-0" data-id="element-584">
              © 2023 EU Holidays. All rights reserved.
            </div>
            <div className="flex flex-wrap gap-4" data-id="element-585">
              <img src="https://upload.wikimedia.org/wikipedia/commons/5/5e/Visa_Inc._logo.svg" alt="Visa" className="h-6" data-id="element-586" />
              <img src="https://upload.wikimedia.org/wikipedia/commons/2/2a/Mastercard-logo.svg" alt="Mastercard" className="h-6" data-id="element-587" />
              <img src="https://upload.wikimedia.org/wikipedia/commons/b/b5/PayPal.svg" alt="PayPal" className="h-6" data-id="element-588" />
              <img src="https://upload.wikimedia.org/wikipedia/commons/f/fa/American_Express_logo_%282018%29.svg" alt="American Express" className="h-6" data-id="element-589" />
            </div>
          </div>
        </div>
      </div>
    </footer>;
}